module.exports = __webpack_public_path__ + "static/assets/61b9d7fe1f29b538c4312365c8c7260a.png";